import {createSlice} from '@reduxjs/toolkit';
import API from '../../common/api';
import {setNote} from '../note/noteSlice';


export const inviteSlice = createSlice({
    name: 'invite',
    initialState: {
        showPopup: false,
        currCircleInviteLink: '',
    },
    reducers: {
        setShowInvitePopup: (state, action) => {
            state.showPopup = action.payload;
        },
        setLink: (state, action) => {
            state.currCircleInviteLink = action.payload;
        },
    }
});


export const {
    setShowInvitePopup,
    setLink
} = inviteSlice.actions;

export const generateCircleInvite = (token, circleID) => async (dispatch) => {
    const res = await API.getInviteLink({token, circleID});
    dispatch(setLink(res.data.app_link));
};

export const sendInviteFromCircleToUser = (token, circleID, userID) => async (dispatch) => {
    const res = await API.sendInviteToUser({token, circleID, userID});
    if (res.status === 200) {
        dispatch(setNote({show: true, text: 'Member invited successfully'}));
    }
};

export const selectInviteShow = state => state.invite.showPopup;
export const selectLink = state => state.invite.currCircleInviteLink;


export default inviteSlice.reducer;